
import { debounce } from "debounce";
export default {
  name: "elasticFilters",
  data() {
    return {
      more: {},
      heights:{},
      moreInput: {},
      debounce,
      open: false,
      priceRange: { min: 0, max: 0, from: 0, to: 0, ready: false },
      filters: {
        business_activity: [{}],
      },
    };
  },
  watch: {
    open: {
      handler(v) {
        if (process.browser) {
          if (v || this.$store.getters.lockOpen("filters")) {
            document.querySelector("body").classList.add("overflow-hidden");
          } else {
            document.querySelector("body").classList.remove("overflow-hidden");
          }
        }
      },
      immediate: true,
    },
    "$store.state.catalogue": {
      handler(v) {
      },
      deep: true,
    },
  },
  mounted() {
    this.$nuxt.$on("filterToggle", (v) => {
      this.open = !this.open;
      this.$store.commit("lockOpen", { key: "filters", value: this.open });
      this.$forceUpdate();
    });
  },
  methods: {
    isChecked(c, k) {
      let checked = false;
      if(c.key.includes("tag.") && !this.$store.getters.store.eshop.tagsMultiple){
        checked = (this.$store.getters.filters.tags || "") == (k.key || "").split(" | ")[0]
      }else{
        let key = (k.key || "").split(" | ")[0];
        let slug = (k.slug || "").split(" | ")[0];
        let extra = `tag.${this.$hyperUtility.slugifyGreek(c.key.replace().replace("tag.", ""))}`
        let splitter = (this.$store.getters.filters[c.key]+'').split('_or_');
        splitter.forEach((s)=>{
          if(s == key){
            checked = true;
          }
        })
        if(!checked && slug){
          checked = ( this.$store.getters.filters[extra] || "" ).includes(slug);
        }
      }
      return checked;
    },
    calculateHeight(selector) {
      if (process.browser) {
        let el = document.querySelector(`${selector} .content`);
        if (!el) {
          return;
        }
        this.$hyperUtility.vSet(
          this.heights,
          `dom${selector.replace(/\#|\./g, "")}`,
          el.scrollHeight
        );
        let self = this;
        window.addEventListener("resize", (_) => {
          self.$hyperUtility.vSet(
            this.heights,
            `dom${selector.replace(/\#|\./g, "")}`,
            el.scrollHeight
          );
        });
      }
    },
    showLess(k) {
      delete this.more[k];
      delete this.moreInput[k];
      this.$forceUpdate();
    },
    async fetchMore(k) {
      let t = await this.$store.dispatch("filters", {
        size: 1000,
        aggs: [k],
        partial: true,
      });
      this.more[k] = t[k].filter((x) => x.key);
      this.moreInput[k] = "";
      this.$forceUpdate();
    },
    pricesChanges() {
      // this.priceRange.ready = false;
      let self = this;
      self.$router.push(
        self.$hyperUtility.urlElasticCreator(
          "price",
          `${self.priceRange.from}-${self.priceRange.to}`
        )
      );
    },
    createPriceRange() {
      if (!Array.isArray(this.$store.getters.catalogue)) {
        return;
      }
      let prices = (
        (this.$store.getters.catalogue.find((e) => e.key == "prices") || {})
          .prices || []
      ).map((e) => e.key);
      if (prices) {
        this.priceRange.min = Math.min(...prices);
        this.priceRange.max = Math.max(...prices);
        let f = this.$store.getters.filters.price || false;
        let from,
          to = 0;
        if (f) {
          f = f.split("-");
          from = parseInt(f[0]);
          to = parseInt(f[1]);
        }
        this.priceRange.from =
          (from || Math.min(...prices)) - 1 < 0
            ? 0
            : (from || Math.min(...prices)) - 1;
        this.priceRange.to = (to || Math.max(...prices)) + 1;
      }
    },
    async selectFilter(value, key) {
      let inc = (((value || {}).value || "").split("+") || []).reduce(
        (acc, _) => {
          if (_) {
            let k = _.split("=")[0];
            let v = _.split("=")[1];
            acc[k] = v;
          }
          return acc;
        },
        {}
      );
      if (!inc.orderby && key != "limit") {
        return;
      }
      if (this.$store.getters.filters.orderby != inc.orderby) {
        this.$store.getters.filters.page = 1;
      } else {
      }
      this.$store.commit("filters", {
        ...this.$store.getters.filters,
        orderby: inc.orderby,
        order: inc.order,
        sorting: key != "limit" ? value : this.$store.getters.filters.sorting,
        limit: key == "limit" ? value : this.$store.getters.filters.limit,
      });
      let t = this.$hyperUtility.urlElasticCreator();
      // if (process.browser) {
      //   location.href = t;
      // } else {
      //   this.$router.push(t);
      // }
      this.$router.push(t);
    },
  },
};
